import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home-circle"><path d="M3.75 7L12 2.25L20.25 7V20.25H3.75V7Z" stroke="currentColor" strokeWidth="1.5"/><path d="M15 12.25C15 13.9069 13.6569 15.25 12 15.25C10.3431 15.25 9 13.9069 9 12.25C9 10.5931 10.3431 9.25 12 9.25C13.6569 9.25 15 10.5931 15 12.25Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconHomeCircle;
